jQuery(function($){
    "use strict";
  
    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 300) {
        $("#pagetop").fadeIn("fast");
      } else {
        $("#pagetop").fadeOut("fast");
      }
    })
    
    
    $(function () {
      var headerHeight = $('header').outerHeight();
      $('a[href^=#]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top-headerHeight;
        $("html, body").animate({scrollTop:position}, 100, "swing");
        return false;
      });
    });
    
    $('.drawerBtn').click(function () {
      if ($(this).hasClass('on')) {
        $(this).removeClass('on');
        $('.menu-global-container').removeClass('on');
      } else {
        $(this).addClass('on');
        $('.menu-global-container').addClass('on');
      }
    });
    
    $('.menu-item-has-children').on('click', function(){
      $(this).toggleClass('on');
    });
    
    $('.overlay').click(function () {
      $('.drawerBtn').removeClass('on');
      $('.menu-global-container').removeClass('on');
      $('.menu-item-has-children').removeClass('on');
    });
    var $header = $('header');
    
  });
  
  
  var i, links, linksLength;
  links = document.links;
  i = 0;
  linksLength = links.length;
  while (i < linksLength) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noopener noreferrer';
    }
    i++;
  }
  